module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-800.756655905d91b77960888262e7d58d35.woff";